import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";

const useStyles = makeStyles(theme => ({
  margin: {
    margin: "15px 20px 0px 20px",
    "@global": {
      ".MuiBadge-colorError": {
        right: "15px"
      }
    }
  }
}));

export default ({ children, count }) => {
  const classes = useStyles();
  return (
    <Badge
      className={classes.margin}
      badgeContent={count}
      showZero
      color="error"
    >
      {children}
    </Badge>
  );
};
